(() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

  // assets/direct-sale.ts
  (() => {
    const log = {
      info: (...a) => console.log("[direct-sale][info]", ...a),
      warn: (...a) => console.warn("[direct-sale][warn]", ...a),
      error: (...a) => console.error("[direct-sale][error]", ...a)
    };
    let phase = "capture";
    let allProducts = {};
    let currentProductHandle = "";
    let variants = [];
    let product = null;
    let selectedVariantId = 0;
    let sessionToken = crypto.randomUUID();
    function getUrlParam(key) {
      return new URLSearchParams(window.location.search).get(key);
    }
    function setUrlParam(key, value) {
      const url = new URL(window.location.href);
      url.searchParams.set(key, value);
      history.replaceState(null, "", url.toString());
    }
    function getBeforeRoomUrl() {
      var _a;
      try {
        const urls = JSON.parse(
          ((_a = document.getElementById("ds-before-room-url")) == null ? void 0 : _a.textContent) || "{}"
        );
        return (product == null ? void 0 : product.collection) === "blackout-perdeler" ? urls.blk || "" : urls.fon || "";
      } catch (_) {
        return "";
      }
    }
    function formatPrice(price) {
      return price.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " TL";
    }
    function injectStyles(id, css) {
      if (document.getElementById(id)) return;
      const style = document.createElement("style");
      style.id = id;
      style.textContent = css;
      document.head.appendChild(style);
    }
    function preloadAllImages() {
      Object.values(allProducts).forEach((p) => {
        p.variants.forEach((v) => {
          if (v.swatchUrl) {
            const i = new Image();
            i.src = v.swatchUrl;
          }
          if (v.imageUrl) {
            const i = new Image();
            i.src = v.imageUrl;
          }
        });
      });
    }
    function init() {
      var _a;
      const allProductsEl = document.getElementById("direct-sale-all-products");
      if (!allProductsEl) {
        log.error("Missing JSON data elements \u2014 aborting");
        return;
      }
      try {
        allProducts = JSON.parse(allProductsEl.textContent || "{}");
      } catch (e) {
        log.error("Product JSON parse failure", e);
        showInitError();
        return;
      }
      const productHandle = getUrlParam("product") || "";
      currentProductHandle = productHandle;
      log.info("allProducts keys", Object.keys(allProducts));
      const productEntry = allProducts[productHandle];
      if (!productHandle || !productEntry) {
        const collectionOrder = ["blackout-perdeler", "fon-perdeler"];
        const firstEntry = Object.entries(allProducts).filter(([, p]) => SWITCHER_COLLECTIONS.includes(p.collection)).sort((a, b) => collectionOrder.indexOf(a[1].collection) - collectionOrder.indexOf(b[1].collection))[0];
        if (firstEntry) {
          const firstVariant = firstEntry[1].variants.find((v) => v.available) || firstEntry[1].variants[0];
          const url = new URL(window.location.href);
          url.searchParams.set("product", firstEntry[0]);
          if (firstVariant) url.searchParams.set("variant", String(firstVariant.id));
          window.location.replace(url.toString());
        } else {
          log.warn("No products found to redirect to");
          const root = document.getElementById("ds-root");
          if (root) root.innerHTML = '<div style="padding:60px 20px;text-align:center;color:#333;font-family:var(--font-body--family,Inter,sans-serif)"><p>\xDCr\xFCn bulunamad\u0131.</p></div>';
        }
        return;
      }
      product = productEntry;
      variants = productEntry.variants || [];
      if (!variants.length) {
        log.error("Empty variant data \u2014 aborting");
        return;
      }
      const paramVariant = getUrlParam("variant");
      const paramId = paramVariant ? parseInt(paramVariant, 10) : NaN;
      const paramMatch = !isNaN(paramId) && variants.find((v) => v.id === paramId);
      if (paramVariant && !paramMatch) {
        log.warn("variant param not found, falling back to first available", paramVariant);
      }
      const firstAvailable = variants.find((v) => v.available) || variants[0];
      selectedVariantId = (_a = paramMatch ? paramMatch.id : firstAvailable == null ? void 0 : firstAvailable.id) != null ? _a : 0;
      if (!paramVariant && selectedVariantId) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", String(selectedVariantId));
        history.replaceState(null, "", url.toString());
      }
      log.info("init", { productHandle: getUrlParam("product"), selectedVariantId });
      document.title = `${product.title} \u2014 Odanda G\xF6r | \u0130nan\xE7 Tekstil`;
      preloadAllImages();
      renderPageHeader();
      renderProductSwitcher();
      renderVariantStrip();
      renderDropper();
      renderExampleStrip();
      setupPhaseCapture();
    }
    function showInitError() {
      const root = document.getElementById("ds-root");
      if (!root) return;
      root.innerHTML = '<div style="padding:40px;text-align:center;color:#c00;">Sayfa y\xFCklenemedi, l\xFCtfen yenileyin.</div>';
    }
    const PAGE_CHROME_STYLES = `
    /* Hide site nav, announcement bar on direct sale page */
    header-component,
    announcement-bar-component,
    #shopify-section-header_announcements_9jGBFp,
    #shopify-section-group-header-group {
      display: none !important;
    }
    /* Hide WhatsApp floating button (but not our contact section links) */
    a[href*="wa.me"]:not(.ds-contact-link) {
      display: none !important;
    }
    /* Prevent horizontal overflow from variant strip */
    #ds-root {
      overflow-x: hidden;
    }
    #ds-capture-body {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
    /* Minimal logo-only bar replacement */
    #ds-minimal-header {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 14px 20px;
      border-bottom: 1px solid #E5E5E5;
      margin-bottom: 4px;
    }
    #ds-minimal-header img {
      height: 32px;
      width: auto;
    }
    #ds-minimal-header span {
      font-family: 'Playfair Display', Georgia, serif;
      font-size: 1.1rem;
      font-weight: 700;
      color: #1B2A4A;
      letter-spacing: 0.02em;
    }
    #ds-nav-back-btn {
      position: absolute;
      left: 20px;
      display: none;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1.5px solid #E5E5E5;
      background: #fff;
      cursor: pointer;
      color: #1B2A4A;
      box-shadow: 0 1px 4px rgba(0,0,0,0.08);
    }
  `;
    const HEADER_STYLES = `
    .ds-step-heading {
      font-family: var(--font-body--family, Inter, sans-serif);
      font-size: 1.5rem;
      font-weight: 700;
      color: #1B2A4A;
      margin: 0 0 12px;
      line-height: 1.3;
    }
    #ds-page-header {
      margin-top: 24px;
    }
  `;
    function renderPageHeader() {
      var _a, _b;
      const capture = document.getElementById("ds-phase-capture");
      if (!capture || !product) return;
      injectStyles("ds-page-chrome-styles", PAGE_CHROME_STYLES);
      injectStyles("ds-header-styles", HEADER_STYLES);
      document.querySelectorAll('footer .section, contentinfo .section, [id*="shopify-section"] .section').forEach((el) => {
        if (el.querySelector('input[type="email"]')) {
          el.style.display = "none";
        }
      });
      document.querySelectorAll("#shopify-section-group-footer-group > *").forEach((el) => {
        if (el.querySelector('input[type="email"]')) {
          el.style.display = "none";
        }
      });
      if (!document.getElementById("ds-minimal-header")) {
        const root = document.getElementById("ds-root");
        const bar = document.createElement("div");
        bar.id = "ds-minimal-header";
        bar.innerHTML = `
        <button id="ds-nav-back-btn" type="button" aria-label="Geri">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <img src="https://inanctekstil.store/cdn/shop/files/inanc-tekstil-logo.svg?v=1773592887" alt="\u0130nan\xE7 Tekstil">
      `;
        (_a = root == null ? void 0 : root.parentNode) == null ? void 0 : _a.insertBefore(bar, root);
        (_b = document.getElementById("ds-nav-back-btn")) == null ? void 0 : _b.addEventListener("click", () => {
          setPhase("capture");
          renderVariantStrip();
          renderDropper();
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      }
    }
    const SWITCHER_COLLECTIONS = ["fon-perdeler", "blackout-perdeler"];
    const MODEL_CARD_SKU = {
      "100-blackout-blackout-perde": "BLK-133",
      "dark-blackout-blackout-perde": "BLK-021",
      "havuz-blackout-blackout-perde": "BLK-106",
      "hermes-blackout-blackout-perde": "BLK-067",
      "enza-fon-perde": "FON-002",
      "monica-fon-perde": "FON-021",
      "sultan-22260-fon-perde": "FON-027",
      "suet-fon-perde": "FON-102",
      "yagmur-fon-perde": "FON-137"
    };
    const COLLECTION_LABELS = {
      "fon-perdeler": "Fon",
      "blackout-perdeler": "Blackout"
    };
    const PRODUCT_SWITCHER_STYLES = `
    #ds-product-section {
      margin-bottom: 20px;
    }
    .ds-strip-wrap {
      position: relative;
      margin: 0 -16px;
    }
    .ds-strip-wrap::before,
    .ds-strip-wrap::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 16px;
      pointer-events: none;
      z-index: 2;
    }
    .ds-strip-wrap::before {
      left: 0;
      background: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%);
    }
    .ds-strip-wrap::after {
      right: 0;
      background: linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%);
    }
    #ds-product-strip {
      display: flex;
      flex-direction: row;
      gap: 10px;
      overflow-x: auto;
      padding: 6px 16px 8px;
      scrollbar-width: none;
    }
    #ds-product-strip::-webkit-scrollbar { display: none; }
    .ds-product-card {
      flex: 0 0 auto;
      width: 144px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0,0,0,0.10);
      transition: box-shadow 0.15s;
      position: relative;
    }
    .ds-product-card.selected {
      box-shadow: 0 0 0 2px #1B2A4A, 0 2px 8px rgba(0,0,0,0.10);
    }
    .ds-product-card.selected::after {
      content: '\u2713';
      position: absolute;
      top: 4px;
      right: 4px;
      width: 18px;
      height: 18px;
      background: #1B2A4A;
      color: #fff;
      border-radius: 50%;
      font-size: 10px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 18px;
      text-align: center;
    }
    .ds-product-card__img {
      width: 100%;
      height: 144px;
      overflow: hidden;
      background: #f5f5f5;
      border-radius: 8px 8px 0 0;
    }
    .ds-product-card__img img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .ds-product-card__body {
      padding: 5px 6px 6px;
    }
    .ds-product-card__badge {
      display: inline-block;
      font-size: 0.6rem;
      font-weight: 600;
      letter-spacing: 0.03em;
      text-transform: uppercase;
      color: #fff;
      background: #1B2A4A;
      border-radius: 3px;
      padding: 1px 5px;
      margin-bottom: 3px;
    }
    .ds-product-card__badge.fon { background: #4a7c6f; }
    .ds-product-card__name {
      font-size: 0.68rem;
      color: #333;
      line-height: 1.3;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  `;
    function renderProductSwitcher() {
      var _a;
      const strip = document.getElementById("ds-variant-strip");
      if (!strip) return;
      injectStyles("ds-product-switcher-styles", PRODUCT_SWITCHER_STYLES);
      const PRODUCT_ORDER = {
        "havuz-blackout-blackout-perde": 0
      };
      const switcherProducts = Object.entries(allProducts).filter(([, p]) => SWITCHER_COLLECTIONS.includes(p.collection)).sort((a, b) => {
        var _a2, _b;
        const collOrder = ["blackout-perdeler", "fon-perdeler"];
        const collDiff = collOrder.indexOf(a[1].collection) - collOrder.indexOf(b[1].collection);
        if (collDiff !== 0) return collDiff;
        return ((_a2 = PRODUCT_ORDER[a[0]]) != null ? _a2 : 999) - ((_b = PRODUCT_ORDER[b[0]]) != null ? _b : 999);
      });
      if (switcherProducts.length <= 1) return;
      let section = document.getElementById("ds-product-section");
      if (!section) {
        section = document.createElement("div");
        section.id = "ds-product-section";
        const label = document.createElement("div");
        label.className = "ds-section-label";
        label.textContent = "\xDCR\xDCN";
        const productStrip2 = document.createElement("div");
        productStrip2.id = "ds-product-strip";
        const productWrap = document.createElement("div");
        productWrap.className = "ds-strip-wrap";
        productWrap.appendChild(productStrip2);
        section.appendChild(label);
        section.appendChild(productWrap);
        const variantSection = document.getElementById("ds-variant-section");
        const insertBefore = variantSection || strip;
        (_a = insertBefore.parentNode) == null ? void 0 : _a.insertBefore(section, insertBefore);
      }
      const productStrip = document.getElementById("ds-product-strip");
      productStrip.innerHTML = "";
      switcherProducts.forEach(([handle, p]) => {
        const preferredSku = MODEL_CARD_SKU[handle];
        const thumbVariant = preferredSku && p.variants.find((v) => v.sku === preferredSku) || p.variants[0];
        const thumbUrl = (thumbVariant == null ? void 0 : thumbVariant.swatchUrl) || (thumbVariant == null ? void 0 : thumbVariant.imageUrl) || "";
        const collectionKey = p.collection;
        const badgeLabel = COLLECTION_LABELS[collectionKey] || collectionKey;
        const isSelected = handle === currentProductHandle;
        const card = document.createElement("div");
        card.className = "ds-product-card" + (isSelected ? " selected" : "");
        card.setAttribute("role", "button");
        card.setAttribute("tabindex", "0");
        card.setAttribute("aria-label", p.title);
        card.setAttribute("aria-pressed", String(isSelected));
        card.innerHTML = `
        <div class="ds-product-card__img">
          ${thumbUrl ? `<img src="${thumbUrl}" alt="${p.title}" loading="lazy">` : ""}
        </div>
        <div class="ds-product-card__body">
          <div class="ds-product-card__badge ${collectionKey === "fon-perdeler" ? "fon" : ""}">${badgeLabel}</div>
          <div class="ds-product-card__name">${p.title}</div>
        </div>
      `;
        card.addEventListener("click", () => onProductClick(handle));
        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") onProductClick(handle);
        });
        productStrip.appendChild(card);
      });
      requestAnimationFrame(() => {
        const selectedCard = productStrip.querySelector(".ds-product-card.selected");
        if (selectedCard) {
          const containerRect = productStrip.getBoundingClientRect();
          const cardRect = selectedCard.getBoundingClientRect();
          productStrip.scrollLeft += cardRect.left - containerRect.left - productStrip.clientWidth / 2 + selectedCard.clientWidth / 2;
        }
      });
    }
    function onProductClick(handle) {
      var _a, _b;
      if (handle === currentProductHandle) return;
      const newProduct = allProducts[handle];
      if (!newProduct) {
        log.warn("onProductClick: handle not found", handle);
        return;
      }
      product = newProduct;
      variants = newProduct.variants || [];
      currentProductHandle = handle;
      const firstAvailable = variants.find((v) => v.available) || variants[0];
      selectedVariantId = (_a = firstAvailable == null ? void 0 : firstAvailable.id) != null ? _a : 0;
      formState.en = 0;
      formState.boy = 0;
      formState.enValid = false;
      formState.boyValid = false;
      const url = new URL(window.location.href);
      url.searchParams.set("product", handle);
      url.searchParams.delete("variant");
      history.replaceState(null, "", url.toString());
      document.title = `${product.title} \u2014 Odanda G\xF6r | \u0130nan\xE7 Tekstil`;
      renderProductSwitcher();
      renderVariantStrip();
      recalcPrice();
      log.info("product switched", { handle, selectedVariantId });
      (_b = window.posthog) == null ? void 0 : _b.capture("direct_sale_product_switched", {
        to_product: handle,
        to_variant: selectedVariantId
      });
    }
    const STRIP_STYLES = `
    #ds-variant-section {
      margin-bottom: 20px;
    }
    .ds-section-label {
      font-size: 0.75rem;
      font-weight: 600;
      color: #888;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      margin-bottom: 8px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-variant-strip {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      gap: 8px;
      padding: 6px 16px 10px;
      scrollbar-width: none;
      -webkit-overflow-scrolling: touch;
      width: 100%;
      min-width: 0;
    }
    #ds-variant-strip::-webkit-scrollbar { display: none; }
    .ds-variant-card {
      flex: 0 0 auto;
      width: 76px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0,0,0,0.10);
      transition: box-shadow 0.15s;
      box-sizing: border-box;
    }
    .ds-variant-card.selected {
      box-shadow: 0 0 0 2px #1B2A4A, 0 2px 8px rgba(0,0,0,0.10);
    }
    .ds-variant-card.selected::after {
      content: '\u2713';
      position: absolute;
      top: 4px;
      right: 4px;
      width: 18px;
      height: 18px;
      background: #1B2A4A;
      color: #fff;
      border-radius: 50%;
      font-size: 10px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 18px;
      text-align: center;
    }
    .ds-variant-card {
      position: relative;
    }
    .ds-variant-card__img {
      width: 100%;
      height: 72px;
      overflow: hidden;
      border-radius: 8px 8px 0 0;
    }
    .ds-variant-card__img img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .ds-variant-card__label {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 9px;
      color: #555;
      font-family: var(--font-body--family, Inter, sans-serif);
      padding: 0 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-top: 1px solid #F0F0F0;
    }
  `;
    function renderVariantStrip() {
      var _a;
      const strip = document.getElementById("ds-variant-strip");
      if (!strip) return;
      injectStyles("ds-variant-styles", STRIP_STYLES);
      if (!document.getElementById("ds-variant-section")) {
        const section = document.createElement("div");
        section.id = "ds-variant-section";
        (_a = strip.parentNode) == null ? void 0 : _a.insertBefore(section, strip);
        const label = document.createElement("div");
        label.className = "ds-section-label";
        label.textContent = "RENK";
        const variantWrap = document.createElement("div");
        variantWrap.className = "ds-strip-wrap";
        variantWrap.appendChild(strip);
        section.appendChild(label);
        section.appendChild(variantWrap);
      }
      strip.innerHTML = "";
      variants.forEach((variant) => {
        const card = document.createElement("div");
        card.className = "ds-variant-card" + (variant.id === selectedVariantId ? " selected" : "");
        card.dataset.variantId = String(variant.id);
        card.setAttribute("role", "button");
        card.setAttribute("aria-label", variant.sku);
        card.setAttribute("tabindex", "0");
        const imgEl = document.createElement("div");
        imgEl.className = "ds-variant-card__img";
        const img = document.createElement("img");
        img.src = variant.swatchUrl || variant.imageUrl || "";
        img.alt = variant.sku;
        img.loading = "lazy";
        imgEl.appendChild(img);
        const label = document.createElement("div");
        label.className = "ds-variant-card__label";
        label.textContent = variant.sku;
        card.appendChild(imgEl);
        card.appendChild(label);
        card.addEventListener("click", () => onVariantClick(variant.id));
        card.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") onVariantClick(variant.id);
        });
        strip.appendChild(card);
      });
      requestAnimationFrame(() => {
        const selectedCard = strip.querySelector(".ds-variant-card.selected");
        if (selectedCard) {
          const containerRect = strip.getBoundingClientRect();
          const cardRect = selectedCard.getBoundingClientRect();
          strip.scrollLeft += cardRect.left - containerRect.left - strip.clientWidth / 2 + selectedCard.clientWidth / 2;
        }
      });
    }
    function onVariantClick(variantId) {
      var _a;
      if (variantId === selectedVariantId) return;
      const prevId = selectedVariantId;
      selectedVariantId = variantId;
      setUrlParam("variant", String(variantId));
      document.querySelectorAll(".ds-variant-card").forEach((card) => {
        const el = card;
        if (parseInt(el.dataset.variantId || "", 10) === variantId) {
          el.classList.add("selected");
        } else {
          el.classList.remove("selected");
        }
      });
      log.info("variant changed", { from: prevId, to: variantId });
      recalcPrice();
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_variant_changed", {
          product_id: product.id,
          from_variant_id: prevId,
          to_variant_id: variantId
        });
      }
    }
    const EXAMPLE_STRIP_STYLES = `
    #ds-examples {
      margin: 8px -16px 8px;
      overflow: hidden;
      position: relative;
    }
    #ds-examples::before,
    #ds-examples::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 16px;
      pointer-events: none;
      z-index: 2;
    }
    #ds-examples::before {
      left: 0;
      background: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%);
    }
    #ds-examples::after {
      right: 0;
      background: linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0.6) 40%, rgba(255,255,255,0) 100%);
    }
    .ds-examples-scroll {
      display: flex;
      will-change: transform;
    }
    .ds-example-card {
      flex-shrink: 0;
      width: 152px;
      margin-right: 16px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      aspect-ratio: 3/4;
      box-shadow: 0 1px 4px rgba(0,0,0,0.12);
      cursor: ew-resize;
      user-select: none;
      touch-action: pan-y;
    }
    .ds-ex-after,
    .ds-ex-before {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      pointer-events: none;
    }
    .ds-ex-handle {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 26px;
      height: 26px;
      background: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      box-shadow: 0 1px 5px rgba(0,0,0,0.35);
      z-index: 3;
      pointer-events: none;
    }
    .ds-ex-handle::before {
      content: '';
      position: absolute;
      left: 50%;
      top: -500px;
      bottom: -500px;
      width: 2px;
      background: white;
      transform: translateX(-50%);
      z-index: -1;
    }
    .ds-ex-lbl {
      position: absolute;
      bottom: 6px;
      font-size: 9px;
      font-weight: 700;
      color: white;
      text-shadow: 0 1px 3px rgba(0,0,0,0.7);
      letter-spacing: 0.5px;
      text-transform: uppercase;
      pointer-events: none;
      z-index: 2;
    }
    .ds-ex-lbl-l { left: 6px; }
    .ds-ex-lbl-r { right: 6px; }
  `;
    let carouselPaused = false;
    function setCarouselPaused(paused) {
      carouselPaused = paused;
    }
    function startCarousel(track, originalCount) {
      const SPEED = 0.045;
      let offset = 0;
      let lastTime = null;
      function getSetWidth() {
        const cards = track.querySelectorAll(".ds-example-card");
        let w = 0;
        for (let i = 0; i < originalCount; i++) {
          const card = cards[i];
          if (!card) break;
          const style = getComputedStyle(card);
          w += card.offsetWidth + parseFloat(style.marginRight || "0");
        }
        return w;
      }
      let setWidth = 0;
      function tick(time) {
        if (lastTime !== null && !carouselPaused) {
          const delta = time - lastTime;
          if (!setWidth) setWidth = getSetWidth();
          offset += SPEED * delta;
          if (setWidth > 0 && offset >= setWidth) offset -= setWidth;
          track.style.transform = `translateX(-${offset}px)`;
        }
        lastTime = time;
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      track.addEventListener("mouseenter", () => setCarouselPaused(true));
      track.addEventListener("mouseleave", () => setCarouselPaused(false));
    }
    function buildExampleSlider(card) {
      const before = card.querySelector(".ds-ex-before");
      const handle = card.querySelector(".ds-ex-handle");
      if (!before || !handle) return;
      let dragging = false;
      function update(pct2) {
        const c = Math.max(2, Math.min(98, pct2));
        before.style.clipPath = `inset(0 ${100 - c}% 0 0)`;
        handle.style.left = c + "%";
      }
      function pct(clientX) {
        const r = card.getBoundingClientRect();
        return (clientX - r.left) / r.width * 100;
      }
      card.addEventListener("mousedown", (e) => {
        dragging = true;
        setCarouselPaused(true);
        update(pct(e.clientX));
        e.preventDefault();
      });
      window.addEventListener("mousemove", (e) => {
        if (dragging) update(pct(e.clientX));
      });
      window.addEventListener("mouseup", () => {
        if (dragging) {
          dragging = false;
          setCarouselPaused(false);
        }
      });
      card.addEventListener("touchstart", (e) => {
        dragging = true;
        setCarouselPaused(true);
        if (e.touches[0]) update(pct(e.touches[0].clientX));
        e.preventDefault();
      }, { passive: false });
      window.addEventListener("touchmove", (e) => {
        if (dragging && e.touches[0]) update(pct(e.touches[0].clientX));
      }, { passive: true });
      window.addEventListener("touchend", () => {
        if (dragging) {
          dragging = false;
          setCarouselPaused(false);
        }
      });
      update(50);
    }
    function renderExampleStrip() {
      var _a;
      const el = document.getElementById("ds-examples");
      if (!el) return;
      const rooms = JSON.parse(
        ((_a = document.getElementById("ds-example-rooms")) == null ? void 0 : _a.textContent) || "[]"
      );
      if (rooms.length === 0) return;
      injectStyles("ds-example-strip-styles", EXAMPLE_STRIP_STYLES);
      const cards = rooms.map((r) => `
      <div class="ds-example-card">
        <img class="ds-ex-after"  src="${r.after}"  alt="Sonra" loading="lazy">
        <img class="ds-ex-before" src="${r.before}" alt="\xD6nce"  loading="lazy">
        <div class="ds-ex-handle">\u21C4</div>
        <span class="ds-ex-lbl ds-ex-lbl-l">\xD6nce</span>
        <span class="ds-ex-lbl ds-ex-lbl-r">Sonra</span>
      </div>
    `).join("");
      el.innerHTML = `<div class="ds-examples-scroll">${cards}${cards}</div>`;
      el.querySelectorAll(".ds-example-card").forEach(buildExampleSlider);
      const track = el.querySelector(".ds-examples-scroll");
      if (track) startCarousel(track, rooms.length);
      if (!document.getElementById("ds-social-proof")) {
        const proof = document.createElement("div");
        proof.id = "ds-social-proof";
        proof.className = "ds-social-proof";
        proof.innerHTML = "\u{1F3E0} Bu ay <strong>1500+</strong> ki\u015Fi odas\u0131n\u0131 d\xF6n\xFC\u015Ft\xFCrd\xFC";
        el.insertAdjacentElement("afterend", proof);
      }
      const dropper = document.getElementById("ds-dropper");
      if (dropper && dropper.parentNode) {
        dropper.parentNode.insertBefore(el, dropper);
        const proof = document.getElementById("ds-social-proof");
        if (proof) dropper.parentNode.insertBefore(proof, dropper);
      }
    }
    const DROPPER_STYLES = `
    #ds-dropper {
      border: none;
      border-radius: 12px;
      min-height: 260px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 96px 36px;
      cursor: pointer;
      position: relative;
      background: #fafbfd;
      background-image: var(--ds-dropper-bg, none);
      background-size: cover;
      background-position: center;
      transition: border-color 0.15s, background 0.15s;
      box-sizing: border-box;
      width: 100%;
      overflow: hidden;
    }
    #ds-dropper::before {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(250, 251, 253, 0.75);
      border-radius: 10px;
      pointer-events: none;
    }
    #ds-dropper.drag-over {
      filter: brightness(0.97);
    }
    #ds-dropper.drag-over::before {
      background: rgba(238, 241, 247, 0.82);
    }
    #ds-dropper svg {
      display: block;
      margin: 0 auto 16px;
    }
    #ds-dropper .ds-dropper-primary {
      font-weight: 700;
      color: #1B2A4A;
      font-size: 1rem;
      text-align: center;
      margin-bottom: 6px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-dropper .ds-dropper-secondary {
      font-size: 0.8rem;
      color: #666;
      text-align: center;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-dropper .ds-dropper-cta {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      margin-top: 16px;
      padding: 10px 22px;
      background: #1B2A4A;
      color: #fff;
      border-radius: 8px;
      font-size: 0.9rem;
      font-weight: 600;
      font-family: var(--font-body--family, Inter, sans-serif);
      pointer-events: none;
      line-height: 1;
    }
    #ds-dropper .ds-dropper-cta svg {
      display: block;
      flex-shrink: 0;
      margin: 0;
    }
    #ds-dropper .ds-dropper-error {
      color: #c00;
      font-size: 0.85rem;
      text-align: center;
      margin-top: 10px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-dropper input[type=file] {
      position: absolute;
      inset: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
    #ds-skip-photo {
      display: block;
      margin-top: 12px;
      margin-bottom: 40px;
      font-size: 0.875rem;
      font-weight: 500;
      color: #1B2A4A;
      text-align: center;
      cursor: pointer;
      font-family: var(--font-body--family, Inter, sans-serif);
      background: #F0F2F7;
      border: none;
      border-radius: 10px;
      padding: 12px 16px;
      width: 100%;
    }
    #ds-skip-photo:hover { background: #E2E6EF; }
  `;
    const CAMERA_SVG = `<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style="position:relative;z-index:1">
  <circle cx="28" cy="28" r="28" fill="rgba(27,42,74,0.10)"/>
  <path d="M18 22h2.5l2-3h11l2 3H38a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V24a2 2 0 0 1 2-2z" stroke="#1B2A4A" stroke-width="1.8" fill="none" stroke-linejoin="round"/>
  <circle cx="28" cy="31" r="4.5" stroke="#1B2A4A" stroke-width="1.8" fill="none"/>
  <circle cx="36.5" cy="25.5" r="1" fill="#1B2A4A"/>
</svg>`;
    function renderDropper() {
      var _a;
      const dropper = document.getElementById("ds-dropper");
      if (!dropper) return;
      injectStyles("ds-dropper-styles", DROPPER_STYLES);
      injectStyles("ds-social-proof-styles", `
      .ds-social-proof {
        font-size: 12.5px;
        color: #555;
        text-align: center;
        margin-top: 12px;
        margin-bottom: 36px;
      }
      .ds-social-proof strong { color: #1B2A4A; }
    `);
      const bgUrl = getBeforeRoomUrl();
      if (bgUrl) dropper.style.setProperty("--ds-dropper-bg", `url(${bgUrl})`);
      dropper.innerHTML = `
      ${CAMERA_SVG}
      <div class="ds-dropper-primary" style="position:relative;z-index:1">Odan\u0131z\u0131 foto\u011Fraflay\u0131n</div>
      <div class="ds-dropper-secondary" style="position:relative;z-index:1">Pencereyi merkeze al\u0131n \u2014 dikine \xE7ekilen foto\u011Fraflar daha iyi sonu\xE7 verir</div>
      <div class="ds-dropper-cta" style="position:relative;z-index:1">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg>
        <span>Odam\u0131 D\xF6n\xFC\u015Ft\xFCr</span>
      </div>
      <input type="file" accept="image/jpeg,image/png,image/webp" id="ds-file-input" aria-label="Oda foto\u011Fraf\u0131 se\xE7">
    `;
      (_a = document.getElementById("ds-skip-photo")) == null ? void 0 : _a.remove();
      const skipBtn = document.createElement("button");
      skipBtn.id = "ds-skip-photo";
      skipBtn.type = "button";
      skipBtn.textContent = "\xD6rnek odada nas\u0131l g\xF6r\xFCn\xFCr? \u2192";
      dropper.insertAdjacentElement("afterend", skipBtn);
      const fileInput = dropper.querySelector("#ds-file-input");
      fileInput.addEventListener("change", () => {
        if (fileInput.files && fileInput.files[0]) {
          handleFileSelected(fileInput.files[0]);
        }
      });
      skipBtn == null ? void 0 : skipBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        showDirectResult();
      });
      dropper.addEventListener("dragover", (e) => {
        e.preventDefault();
        dropper.classList.add("drag-over");
      });
      dropper.addEventListener("dragleave", () => {
        dropper.classList.remove("drag-over");
      });
      dropper.addEventListener("drop", (e) => {
        var _a2;
        e.preventDefault();
        dropper.classList.remove("drag-over");
        const file = (_a2 = e.dataTransfer) == null ? void 0 : _a2.files[0];
        if (file) handleFileSelected(file);
      });
    }
    function handleFileSelected(file) {
      var _a, _b;
      const ALLOWED = ["image/jpeg", "image/png", "image/webp"];
      const MAX_BYTES = 10 * 1024 * 1024;
      if (!ALLOWED.includes(file.type) || file.size > MAX_BYTES) {
        log.warn("File rejected", { type: file.type, size: file.size });
        showDropperError("Desteklenmeyen dosya veya boyut \xE7ok b\xFCy\xFCk (max 10 MB).");
        return;
      }
      log.info("file selected", { name: file.name, size: file.size });
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_photo_uploaded", {
          product_id: product.id,
          variant_id: selectedVariantId
        });
        (_b = window.fbq) == null ? void 0 : _b.call(window, "track", "CustomizeProduct", {
          content_ids: [String(product.id)],
          content_name: product.title,
          currency: "TRY",
          value: 50
        });
      }
      startGeneration(file);
    }
    function showDropperError(msg) {
      const dropper = document.getElementById("ds-dropper");
      if (!dropper) return;
      const existing = dropper.querySelector(".ds-dropper-error");
      if (existing) existing.remove();
      const err = document.createElement("div");
      err.className = "ds-dropper-error";
      err.textContent = msg;
      dropper.appendChild(err);
    }
    const CONTACT_STYLES = `
    .ds-contact-link {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      padding: 9px 18px;
      border-radius: 8px;
      font-size: 0.9rem;
      font-weight: 600;
      text-decoration: none !important;
      font-family: var(--font-body--family, Inter, sans-serif);
      transition: opacity 0.15s;
    }
    .ds-contact-link:hover { opacity: 0.82; }
    .ds-contact-link-wa {
      background: #25D366;
      color: #fff;
    }
    .ds-contact-link-ig {
      background: linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
      color: #fff;
    }
  `;
    function setupPhaseCapture() {
      var _a, _b;
      setPhase("capture");
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_viewed", {
          product_id: product.id,
          variant_id: selectedVariantId,
          source: document.referrer
        });
        (_b = window.fbq) == null ? void 0 : _b.call(window, "track", "ViewContent", {
          content_ids: [String(product.id)],
          content_name: product.title,
          content_category: product.collection,
          currency: "TRY",
          value: 0
        });
      }
    }
    function setPhase(newPhase) {
      phase = newPhase;
      const capture = document.getElementById("ds-phase-capture");
      const generating = document.getElementById("ds-phase-generating");
      const result = document.getElementById("ds-phase-result");
      if (capture) capture.style.display = newPhase === "capture" ? "" : "none";
      if (generating) generating.style.display = newPhase === "generating" ? "" : "none";
      if (result) result.style.display = newPhase === "result" ? "" : "none";
      const pageHeader = document.getElementById("ds-page-header");
      if (pageHeader) pageHeader.style.display = newPhase === "capture" ? "" : "none";
      const navBack = document.getElementById("ds-nav-back-btn");
      if (navBack) navBack.style.display = newPhase === "result" ? "flex" : "none";
    }
    const GENERATING_STYLES = `
    #ds-phase-generating {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      min-height: 75vh;
      background: #111;
    }
    #ds-gen-bg {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: blur(8px);
      transform: scale(1.08);
    }
    #ds-gen-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0,0,0,0.35);
    }
    #ds-gen-content {
      position: relative;
      z-index: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 75vh;
      padding: 24px;
      color: #fff;
    }
    #ds-gen-label {
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 12px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-gen-countdown {
      display: none;
    }
    #ds-gen-progress-wrap {
      width: 100%;
      max-width: 320px;
      height: 6px;
      background: rgba(255,255,255,0.25);
      border-radius: 3px;
      overflow: hidden;
    }
    #ds-gen-progress-bar {
      height: 100%;
      width: 0%;
      background: #fff;
      border-radius: 3px;
      transition: width 0.3s ease;
    }
    #ds-gen-progress-bar.error {
      background: #f44;
    }
    #ds-gen-error {
      display: none;
      margin-top: 16px;
      text-align: center;
    }
    #ds-gen-error p {
      font-size: 0.9rem;
      margin-bottom: 10px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-gen-retry-btn {
      padding: 8px 20px;
      background: #fff;
      color: #1B2A4A;
      border: none;
      border-radius: 6px;
      font-weight: 600;
      cursor: pointer;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
  `;
    let countdownInterval = null;
    let progressAnimation = null;
    let rotatingLabelTimeout = null;
    let generationTimeout = null;
    let generationAbortController = null;
    let lastUploadedFile = null;
    let lastUploadedBlobUrl = null;
    function cancelGeneration() {
      if (countdownInterval) clearInterval(countdownInterval);
      if (progressAnimation) clearInterval(progressAnimation);
      if (generationTimeout) clearTimeout(generationTimeout);
      if (rotatingLabelTimeout) clearTimeout(rotatingLabelTimeout);
      generationAbortController == null ? void 0 : generationAbortController.abort();
      generationAbortController = null;
    }
    function startGeneration(file) {
      var _a, _b;
      lastUploadedFile = file;
      lastUploadedBlobUrl = URL.createObjectURL(file);
      injectStyles("ds-generating-styles", GENERATING_STYLES);
      const genDiv = document.getElementById("ds-phase-generating");
      if (!genDiv) return;
      genDiv.innerHTML = `
      <img id="ds-gen-bg" src="${lastUploadedBlobUrl}" alt="">
      <div id="ds-gen-overlay"></div>
      <div id="ds-gen-content">
        <div id="ds-gen-label">Odan\u0131z\u0131n \u0131\u015F\u0131\u011F\u0131 analiz ediliyor\u2026</div>
        <div id="ds-gen-countdown">60</div>
        <div id="ds-gen-progress-wrap">
          <div id="ds-gen-progress-bar"></div>
        </div>
        <div id="ds-gen-error">
          <p>G\xF6rsel olu\u015Fturulamad\u0131. Tekrar deneyin.</p>
          <button id="ds-gen-retry-btn" type="button">Tekrar Dene</button>
        </div>
      </div>
    `;
      (_a = document.getElementById("ds-gen-retry-btn")) == null ? void 0 : _a.addEventListener("click", () => {
        onGenerationRetry();
      });
      setPhase("generating");
      let countdown = 60;
      const countdownEl = document.getElementById("ds-gen-countdown");
      countdownInterval = setInterval(() => {
        countdown = Math.max(0, countdown - 1);
        if (countdownEl) countdownEl.textContent = String(countdown);
      }, 1e3);
      const GEN_LABELS = [
        { ms: 15e3, text: "Perde rengi uygulan\u0131yor\u2026" },
        { ms: 3e4, text: "Son r\xF6tu\u015Flar yap\u0131l\u0131yor\u2026" },
        { ms: 45e3, text: "Neredeyse haz\u0131r\u2026" }
      ];
      const labelEl = document.getElementById("ds-gen-label");
      let labelIdx = 0;
      function scheduleNextLabel() {
        if (labelIdx >= GEN_LABELS.length) return;
        rotatingLabelTimeout = setTimeout(() => {
          if (labelEl) labelEl.textContent = GEN_LABELS[labelIdx].text;
          labelIdx++;
          scheduleNextLabel();
        }, labelIdx === 0 ? GEN_LABELS[0].ms : GEN_LABELS[labelIdx].ms - GEN_LABELS[labelIdx - 1].ms);
      }
      scheduleNextLabel();
      const bar = document.getElementById("ds-gen-progress-bar");
      if (bar) {
        requestAnimationFrame(() => {
          bar.style.transition = "width 55s linear";
          bar.style.width = "95%";
        });
      }
      if (product) {
        log.info("generation started", { productId: product.id, variantId: selectedVariantId });
        (_b = window.posthog) == null ? void 0 : _b.capture("direct_sale_generation_started", {
          product_id: product.id,
          variant_id: selectedVariantId
        });
      }
      const startTime = Date.now();
      generationTimeout = setTimeout(() => {
        onGenerationError("timeout", 0);
      }, 9e4);
      generationAbortController = new AbortController();
      callVisualizerApi(file, generationAbortController.signal).then((resultBlob) => {
        var _a2, _b2;
        if (generationTimeout) clearTimeout(generationTimeout);
        if (countdownInterval) clearInterval(countdownInterval);
        if (progressAnimation) clearInterval(progressAnimation);
        if (rotatingLabelTimeout) clearTimeout(rotatingLabelTimeout);
        const bar2 = document.getElementById("ds-gen-progress-bar");
        if (bar2) {
          bar2.style.transition = "width 0.3s ease";
          bar2.style.width = "100%";
        }
        const durationMs = Date.now() - startTime;
        log.info("generation completed", { durationMs });
        if (product) {
          (_a2 = window.posthog) == null ? void 0 : _a2.capture("direct_sale_generation_completed", {
            product_id: product.id,
            variant_id: selectedVariantId,
            duration_ms: durationMs
          });
          (_b2 = window.fbq) == null ? void 0 : _b2.call(window, "track", "CustomizeProduct", {
            content_ids: [String(product.id)],
            content_name: product.title,
            currency: "TRY",
            value: 150
          });
        }
        setTimeout(() => {
          showResult(resultBlob);
        }, 300);
      }).catch((err) => {
        if ((err == null ? void 0 : err.name) === "AbortError") return;
        if (generationTimeout) clearTimeout(generationTimeout);
        if (countdownInterval) clearInterval(countdownInterval);
        if (rotatingLabelTimeout) clearTimeout(rotatingLabelTimeout);
        log.error("generation API error", err);
        onGenerationError((err == null ? void 0 : err.message) || "error", (err == null ? void 0 : err.status) || 0);
      });
    }
    async function callVisualizerApi(file, signal) {
      var _a;
      const variant = variants.find((v) => v.id === selectedVariantId);
      if (!product || !variant) throw new Error("missing product/variant data");
      const formData = new FormData();
      formData.append("product_id", product.gid);
      formData.append("room_image", file);
      formData.append("product_sku", variant.sku);
      formData.append("product_title", product.title);
      formData.append("product_type", product.type);
      formData.append("product_color", product.color);
      formData.append("product_image_url", (_a = variant.imageUrl) != null ? _a : "");
      const resp = await fetch("https://visualizer.inanctekstil.store/api/visualize", {
        method: "POST",
        body: formData,
        signal
      });
      if (!resp.ok) {
        const body = await resp.text().catch(() => "");
        const err = new Error(`HTTP ${resp.status}: ${body.slice(0, 200)}`);
        err.status = resp.status;
        throw err;
      }
      return resp.blob();
    }
    function onGenerationError(message, status) {
      var _a;
      if (countdownInterval) clearInterval(countdownInterval);
      if (progressAnimation) clearInterval(progressAnimation);
      if (generationTimeout) clearTimeout(generationTimeout);
      if (rotatingLabelTimeout) clearTimeout(rotatingLabelTimeout);
      const bar = document.getElementById("ds-gen-progress-bar");
      if (bar) {
        bar.style.transition = "width 0.3s ease";
        bar.style.width = "100%";
        bar.classList.add("error");
      }
      const errorDiv = document.getElementById("ds-gen-error");
      if (errorDiv) errorDiv.style.display = "block";
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_generation_failed", {
          product_id: product.id,
          variant_id: selectedVariantId,
          error_code: message
        });
      }
    }
    function onGenerationRetry() {
      var _a;
      if (countdownInterval) clearInterval(countdownInterval);
      if (generationTimeout) clearTimeout(generationTimeout);
      if (rotatingLabelTimeout) clearTimeout(rotatingLabelTimeout);
      setPhase("capture");
      renderVariantStrip();
      renderDropper();
      if (lastUploadedFile) {
        const fileInput = document.getElementById("ds-file-input");
        if (fileInput) {
          const dt = new DataTransfer();
          dt.items.add(lastUploadedFile);
          fileInput.files = dt.files;
        }
      }
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_generation_retry", {
          product_id: product.id,
          variant_id: selectedVariantId
        });
      }
    }
    const RESULT_STYLES = `
    #ds-product-summary {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 16px;
    }
    #ds-product-summary-title {
      font-family: var(--font-body--family, Inter, sans-serif);
      font-size: 1.4rem;
      font-weight: 700;
      color: #1B2A4A;
      line-height: 1.2;
    }
    #ds-product-summary-meta {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 4px;
    }
    #ds-product-summary-variant {
      font-family: var(--font-body--family, Inter, sans-serif);
      font-size: 1rem;
      color: #777;
    }
    #ds-product-summary-price {
      font-family: var(--font-body--family, Inter, sans-serif);
      font-size: 1rem;
      font-weight: 600;
      color: #1B2A4A;
    }
    #ds-result-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 28px;
      align-items: start;
    }
    @media (max-width: 767px) {
      #ds-result-grid {
        grid-template-columns: 1fr;
        gap: 20px;
      }
      #ds-slider-actions {
        flex-wrap: wrap;
      }
    }
    /* Before/After Slider */
    #ds-slider {
      position: relative;
      overflow: hidden;
      border-radius: 10px;
      user-select: none;
      touch-action: none;
      background: #111;
      aspect-ratio: 9/16;
      max-width: 80vw;
    }
    #ds-slider img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    #ds-slider-before {
      clip-path: inset(0 0 0 50%);
    }
    #ds-slider-handle {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 16px;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: ew-resize;
      z-index: 10;
    }
    #ds-slider-handle::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 50%;
      width: 2px;
      margin-left: -1px;
      background: rgba(255,255,255,0.85);
    }
    #ds-slider-handle-icon {
      width: 32px;
      height: 32px;
      background: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      z-index: 1;
    }
    .ds-slider-label {
      position: absolute;
      bottom: 10px;
      font-size: 11px;
      font-weight: 600;
      color: #fff;
      background: rgba(0,0,0,0.45);
      padding: 2px 8px;
      border-radius: 10px;
      font-family: var(--font-body--family, Inter, sans-serif);
      z-index: 5;
    }
    #ds-label-before { left: 10px; }
    #ds-label-after  { right: 10px; }
    /* Action buttons */
    #ds-slider-actions {
      display: flex;
      gap: 20px;
      margin-top: 10px;
      padding: 0 4px;
    }
    #ds-regen-btn {
      padding: 8px 16px;
      background: #fff;
      color: #1B2A4A;
      border: 1.5px solid #1B2A4A;
      border-radius: 6px;
      font-size: 0.85rem;
      font-weight: 600;
      cursor: pointer;
      font-family: var(--font-body--family, Inter, sans-serif);
      transition: background 0.15s, color 0.15s;
    }
    #ds-regen-btn:hover {
      background: #1B2A4A;
      color: #fff;
    }
    .ds-action-link {
      padding: 0;
      background: transparent;
      color: #6b7280;
      border: none;
      box-shadow: none;
      border-radius: 0;
      font-size: 0.82rem;
      font-weight: 500;
      cursor: pointer;
      font-family: var(--font-body--family, Inter, sans-serif);
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      transition: color 0.15s;
    }
    .ds-action-link:hover { color: #1B2A4A; }
    /* Order Form */
    #ds-form {
      font-family: var(--font-body--family, Inter, sans-serif);
      color: #333;
    }
    .ds-form-section {
      margin-bottom: 20px;
    }
    .ds-form-label {
      font-weight: 600;
      font-size: 0.8rem;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      margin-bottom: 10px;
      display: block;
      color: #888;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    /* Dimensions */
    .ds-dimensions {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
    .ds-dimension-field label {
      display: block;
      font-size: 0.8rem;
      color: #555;
      margin-bottom: 4px;
      font-weight: 500;
    }
    .ds-dimension-field select {
      width: 100%;
      padding: 10px 12px;
      border: none;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      border-radius: 6px;
      font-size: 1rem;
      box-sizing: border-box;
      font-family: var(--font-body--family, Inter, sans-serif);
      outline: none;
      transition: border-color 0.15s;
      color: #333;
      background: #fff;
      cursor: pointer;
      -webkit-appearance: none;
      appearance: none;
    }
    .ds-dimension-field select:focus {
      box-shadow: 0 0 0 2px rgba(27,42,74,0.2), 0 2px 8px rgba(0,0,0,0.08);
    }
    .ds-dimension-field .ds-field-error {
      font-size: 0.75rem;
      color: #c0392b;
      margin-top: 4px;
    }
    /* Pile grid */
    .ds-pile-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
    .ds-pile-card {
      border: none;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      background: #FAFAFA;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      transition: box-shadow 0.15s, background 0.15s;
    }
    .ds-pile-card.selected {
      box-shadow: 0 0 0 2px #1B2A4A, 0 2px 8px rgba(0,0,0,0.08);
      background: #FFF;
    }
    .ds-pile-card__img {
      width: 100%;
      aspect-ratio: 16/9;
      overflow: hidden;
    }
    .ds-pile-card__img img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .ds-pile-card__body {
      padding: 6px 8px 8px;
    }
    .ds-pile-card__name {
      font-size: 0.8rem;
      font-weight: 600;
      color: #333;
    }
    .ds-pile-card__ratio {
      font-size: 0.72rem;
      color: #888;
      margin-top: 1px;
    }
    .ds-pile-card.selected .ds-pile-card__name {
      color: #1B2A4A;
    }
    .ds-pile-card.selected .ds-pile-card__ratio {
      color: #1B2A4A;
    }
    /* Kanat options */
    .ds-kanat-options {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
    .ds-kanat-option {
      border: none;
      border-radius: 8px;
      padding: 12px 10px 10px;
      cursor: pointer;
      text-align: center;
      background: #FAFAFA;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      transition: box-shadow 0.15s, background 0.15s;
    }
    .ds-kanat-option.selected {
      box-shadow: 0 0 0 2px #1B2A4A, 0 2px 8px rgba(0,0,0,0.08);
      background: #FFF;
    }
    .ds-kanat-option svg {
      display: block;
      margin: 0 auto 6px;
    }
    .ds-kanat-option__label {
      font-size: 0.85rem;
      font-weight: 600;
      color: #333;
    }
    .ds-kanat-option__desc {
      font-size: 0.72rem;
      color: #888;
      margin-top: 2px;
      line-height: 1.3;
    }
    .ds-kanat-option.selected .ds-kanat-option__label {
      color: #1B2A4A;
    }
    /* Price block */
    #ds-price-block {
      background: #F4F6FA;
      border: none;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      border-radius: 8px;
      margin-top: 20px;
      padding: 14px 18px;
      margin-bottom: 16px;
    }
    #ds-price-label {
      font-size: 0.75rem;
      color: #888;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 4px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-price-value {
      font-size: 1.55rem;
      font-weight: 700;
      color: #1B2A4A;
      font-family: 'Playfair Display', Georgia, serif;
      line-height: 1.1;
    }
    #ds-price-formula {
      font-size: 0.78rem;
      color: #888;
      margin-top: 4px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    /* CTA */
    #ds-order-btn {
      width: 100%;
      padding: 13px;
      background: #1B2A4A;
      color: #fff;
      border: none;
      border-radius: 6px;
      font-size: 0.95rem;
      font-weight: 600;
      cursor: pointer;
      font-family: var(--font-body--family, Inter, sans-serif);
      transition: background 0.15s;
      letter-spacing: 0.01em;
    }
    #ds-order-btn:hover:not(:disabled) {
      background: #243a63;
    }
    #ds-order-btn:disabled {
      background: #b0b8c4;
      cursor: not-allowed;
    }
    #ds-checkout-error {
      font-size: 0.85rem;
      color: #c0392b;
      margin-bottom: 8px;
      display: none;
    }
    /* Testimonials */
    #ds-testimonials {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: 28px 0 20px;
      border-top: 1px solid #eee;
      padding-top: 24px;
    }
    .ds-testimonial {
      background: #f8f8f8;
      border-radius: 10px;
      padding: 12px 14px;
      display: flex;
      gap: 12px;
      align-items: flex-start;
    }
    .ds-testimonial-media {
      width: 110px;
      flex-shrink: 0;
      border-radius: 7px;
      overflow: hidden;
      aspect-ratio: 9 / 16;
      background: #000;
      position: relative;
    }
    .ds-testimonial-mute-btn {
      position: absolute;
      bottom: 6px;
      right: 6px;
      width: 26px;
      height: 26px;
      border-radius: 50%;
      background: rgba(0,0,0,0.55);
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      color: #fff;
      transition: background 0.15s;
    }
    .ds-testimonial-mute-btn:hover { background: rgba(0,0,0,0.8); }
    .ds-testimonial-media video,
    .ds-testimonial-media img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .ds-testimonial-body {
      flex: 1;
      min-width: 0;
    }
    .ds-testimonial-stars {
      color: #F4A015;
      font-size: 0.85rem;
      letter-spacing: 1px;
      margin-bottom: 4px;
    }
    .ds-testimonial-text {
      font-size: 0.82rem;
      color: #333;
      margin: 0 0 6px;
      line-height: 1.45;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    .ds-testimonial-author {
      font-size: 0.75rem;
      color: #999;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    /* Result contact CTA */
    #ds-result-contact {
      margin-top: 16px;
    }
    #ds-result-contact-text {
      font-size: 0.875rem;
      color: #555;
      margin: 0 0 16px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-result-contact-links {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    #ds-result-wa-link {
      width: 100%;
      justify-content: center;
    }
    #ds-wa-response-time {
      text-align: center;
      font-size: 0.75rem;
      color: #888;
      margin: -2px 0 4px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-result-ig-link {
      background: transparent;
      color: #999;
      font-size: 0.8rem;
      font-weight: 500;
      text-decoration: underline;
      justify-content: center;
      padding: 4px 0;
    }
    #ds-direct-order-divider {
      text-align: center;
      font-size: 0.75rem;
      color: #aaa;
      margin: 20px 0 12px;
      font-family: var(--font-body--family, Inter, sans-serif);
    }
    #ds-toggle-order-form {
      background: #F0F2F7;
      border: none;
      border-radius: 10px;
      padding: 12px 16px;
      cursor: pointer;
      font-size: 0.875rem;
      color: #1B2A4A;
      font-family: var(--font-body--family, Inter, sans-serif);
      font-weight: 500;
      display: block;
      width: 100%;
      text-align: center;
    }
    #ds-toggle-order-form:hover { background: #E2E6EF; }
    #ds-direct-order-wrap {
      margin-top: 20px;
    }
  `;
    let generatedBlobUrl = null;
    function buildOverlayVariantCardHTML(id) {
      const variant = (product == null ? void 0 : product.variants.find((v) => v.id === selectedVariantId)) || (product == null ? void 0 : product.variants[0]);
      if (!variant) return "";
      const src = variant.swatchUrl || variant.imageUrl || "";
      return `
      <div id="${id}" style="
        position:absolute;top:14px;left:14px;z-index:10;
        width:72px;border-radius:10px;
        background:#fff;
        box-shadow:0 4px 16px rgba(0,0,0,0.28);pointer-events:none;
        display:flex;flex-direction:column;overflow:hidden;
      ">
        <div style="width:72px;height:72px;flex-shrink:0;background-image:url('${src}');background-size:cover;background-position:center;border-radius:10px 10px 0 0;"></div>
        <div style="
          padding:5px 6px 6px;background:#fff;
          border-top:1px solid #EBEBEB;
          font-size:9px;font-weight:400;color:#999;font-family:Inter,sans-serif;
          text-align:center;letter-spacing:0.04em;text-transform:uppercase;
        ">${variant.sku}</div>
      </div>`;
    }
    function buildProductSummaryHTML() {
      const variant = (product == null ? void 0 : product.variants.find((v) => v.id === selectedVariantId)) || (product == null ? void 0 : product.variants[0]);
      if (!product || !variant) return "";
      const priceHtml = variant.price > 0 ? `<span id="ds-product-summary-price">${variant.price.toLocaleString("tr-TR")} TL/m</span>` : "";
      return `
      <div id="ds-product-summary">
        <div id="ds-product-summary-text">
          <div id="ds-product-summary-title">${product.title}</div>
          <div id="ds-product-summary-meta">
            <span id="ds-product-summary-variant">${variant.sku}</span>
            ${priceHtml ? `<span style="color:#ddd;">\u2022</span>${priceHtml}` : ""}
          </div>
        </div>
      </div>
    `;
    }
    function showDirectResult() {
      var _a, _b, _c;
      const variant = product.variants.find((v) => v.id === selectedVariantId) || product.variants[0];
      const roomImageUrl = (variant == null ? void 0 : variant.imageUrl) || "";
      const beforeRoomUrl = getBeforeRoomUrl();
      injectStyles("ds-result-styles", RESULT_STYLES);
      injectStyles("ds-contact-styles", CONTACT_STYLES);
      const sliderCol = document.getElementById("ds-slider-col");
      const formCol = document.getElementById("ds-form-col");
      if (!sliderCol || !formCol) return;
      sliderCol.innerHTML = `
      <div id="ds-slider">
        <img id="ds-slider-after" src="${roomImageUrl}" alt="Sonra">
        <img id="ds-slider-before" src="${beforeRoomUrl}" alt="\xD6nce" style="clip-path: inset(0 50% 0 0);">
        <div id="ds-slider-handle" style="left: 50%;">
          <div id="ds-slider-handle-icon">\u21C4</div>
        </div>
        ${buildOverlayVariantCardHTML("ds-slider-variant-card")}
        <span class="ds-slider-label" id="ds-label-after">Sonra</span>
        <span class="ds-slider-label" id="ds-label-before">\xD6nce</span>
      </div>
      <div id="ds-slider-actions">
        <button class="ds-action-link" id="ds-save-btn" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>Kaydet
        </button>
        <button class="ds-action-link" id="ds-share-btn" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>Payla\u015F
        </button>
      </div>
    `;
      buildSlider();
      (_a = document.getElementById("ds-save-btn")) == null ? void 0 : _a.addEventListener("click", onSave);
      (_b = document.getElementById("ds-share-btn")) == null ? void 0 : _b.addEventListener("click", onShare);
      buildOrderForm(formCol);
      setPhase("result");
      window.scrollTo({ top: 0, behavior: "smooth" });
      (_c = window.posthog) == null ? void 0 : _c.capture("direct_sale_order_form_entered", { skip_photo: true, variant_id: selectedVariantId });
    }
    function showResult(resultBlob) {
      var _a, _b, _c;
      generatedBlobUrl = URL.createObjectURL(resultBlob);
      injectStyles("ds-result-styles", RESULT_STYLES);
      injectStyles("ds-contact-styles", CONTACT_STYLES);
      const sliderCol = document.getElementById("ds-slider-col");
      const formCol = document.getElementById("ds-form-col");
      if (!sliderCol || !formCol) return;
      sliderCol.innerHTML = `
      <div id="ds-slider">
        <img id="ds-slider-after" src="${generatedBlobUrl}" alt="Sonra">
        <img id="ds-slider-before" src="${lastUploadedBlobUrl}" alt="\xD6nce" style="clip-path: inset(0 50% 0 0);">
        <div id="ds-slider-handle" style="left: 50%;">
          <div id="ds-slider-handle-icon">\u21C4</div>
        </div>
        ${buildOverlayVariantCardHTML("ds-slider-variant-card")}
        <span class="ds-slider-label" id="ds-label-after">Sonra</span>
        <span class="ds-slider-label" id="ds-label-before">\xD6nce</span>
      </div>
      <div id="ds-slider-actions">
<button class="ds-action-link" id="ds-save-btn" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>Kaydet
        </button>
        <button class="ds-action-link" id="ds-share-btn" type="button">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>Payla\u015F
        </button>
      </div>
    `;
      buildSlider();
      const afterImg = document.getElementById("ds-slider-after");
      const sliderEl = document.getElementById("ds-slider");
      if (afterImg && sliderEl) {
        const applyRatio = () => {
          if (afterImg.naturalWidth && afterImg.naturalHeight) {
            sliderEl.style.aspectRatio = `${afterImg.naturalWidth} / ${afterImg.naturalHeight}`;
          }
        };
        if (afterImg.complete && afterImg.naturalWidth) applyRatio();
        else afterImg.addEventListener("load", applyRatio, { once: true });
      }
      (_a = document.getElementById("ds-regen-btn")) == null ? void 0 : _a.addEventListener("click", onRegen);
      (_b = document.getElementById("ds-save-btn")) == null ? void 0 : _b.addEventListener("click", onSave);
      (_c = document.getElementById("ds-share-btn")) == null ? void 0 : _c.addEventListener("click", onShare);
      buildOrderForm(formCol);
      setPhase("result");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    function buildSlider() {
      const slider = document.getElementById("ds-slider");
      const handle = document.getElementById("ds-slider-handle");
      const beforeImg = document.getElementById("ds-slider-before");
      if (!slider || !handle || !beforeImg) return;
      let dragging = false;
      function updateSlider(pct) {
        const clamped = Math.max(0, Math.min(100, pct));
        beforeImg.style.clipPath = `inset(0 ${100 - clamped}% 0 0)`;
        handle.style.left = clamped + "%";
      }
      function getPercent(clientX) {
        const rect = slider.getBoundingClientRect();
        return (clientX - rect.left) / rect.width * 100;
      }
      slider.addEventListener("mousedown", (e) => {
        dragging = true;
        updateSlider(getPercent(e.clientX));
        e.preventDefault();
      });
      window.addEventListener("mousemove", (e) => {
        if (dragging) updateSlider(getPercent(e.clientX));
      });
      window.addEventListener("mouseup", () => {
        dragging = false;
      });
      slider.addEventListener("touchstart", (e) => {
        dragging = true;
        if (e.touches[0]) updateSlider(getPercent(e.touches[0].clientX));
        e.preventDefault();
      }, { passive: false });
      window.addEventListener("touchmove", (e) => {
        if (dragging && e.touches[0]) updateSlider(getPercent(e.touches[0].clientX));
      }, { passive: true });
      window.addEventListener("touchend", () => {
        dragging = false;
      });
      updateSlider(50);
    }
    function onRegen() {
      var _a;
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_regenerated", {
          product_id: product.id,
          variant_id: selectedVariantId
        });
      }
      setPhase("capture");
      renderVariantStrip();
      renderDropper();
      if (lastUploadedFile) {
        const fileInput = document.getElementById("ds-file-input");
        if (fileInput) {
          const dt = new DataTransfer();
          dt.items.add(lastUploadedFile);
          fileInput.files = dt.files;
        }
      }
    }
    function onSave() {
      var _a;
      if (!generatedBlobUrl) return;
      if (product) {
        (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_image_saved", {
          product_id: product.id,
          variant_id: selectedVariantId
        });
      }
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      if (isMobile && navigator.share && generatedBlobUrl) {
        fetch(generatedBlobUrl).then((r) => r.blob()).then((blob) => {
          const file = new File([blob], "perde-odanda.jpg", { type: "image/jpeg" });
          navigator.share({ files: [file] }).catch(() => {
          });
        });
      } else {
        const a = document.createElement("a");
        a.href = generatedBlobUrl;
        a.download = "perde-odanda.jpg";
        a.click();
      }
    }
    function onShare() {
      var _a, _b, _c;
      (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_image_shared", {
        product_id: product == null ? void 0 : product.id,
        variant_id: selectedVariantId
      });
      (_b = window.fbq) == null ? void 0 : _b.call(window, "track", "Share", {
        content_ids: product ? [String(product.id)] : [],
        currency: "TRY"
      });
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      const shareUrl = `https://inanctekstil.store/pages/direct${window.location.search}`;
      const shareText = `Odam\u0131 \u0130nan\xE7 Tekstil ile d\xF6n\xFC\u015Ft\xFCrd\xFCm! Sen de odan\u0131 g\xF6rmek i\xE7in dene \u{1F447}`;
      const shareData = { title: "\u0130nan\xE7 Tekstil \u2014 Perdeler", text: shareText, url: shareUrl };
      if (isMobile && navigator.share) {
        if (generatedBlobUrl) {
          fetch(generatedBlobUrl).then((r) => r.blob()).then((blob) => {
            const file = new File([blob], "perde-odanda.jpg", { type: "image/jpeg" });
            navigator.share(__spreadProps(__spreadValues({}, shareData), { files: [file] })).catch(() => navigator.share(shareData).catch(() => {
            }));
          });
        } else {
          navigator.share(shareData).catch(() => {
          });
        }
      } else {
        (_c = navigator.clipboard) == null ? void 0 : _c.writeText(`${shareText}
${shareUrl}`).then(() => {
          const btn = document.getElementById("ds-share-btn");
          if (btn) {
            const orig = btn.textContent;
            btn.textContent = "Kopyaland\u0131";
            setTimeout(() => {
              if (btn) btn.textContent = orig;
            }, 2e3);
          }
        });
      }
    }
    const PILE_OPTIONS = [
      { id: "boru", label: "Boru Pile", ratio: 3, preferred: true, imageUrl: "https://img-tac.sm.mncdn.com/img/attributes/pile-boru.jpeg" },
      { id: "kanun", label: "Kanun Pile", ratio: 3, preferred: false, imageUrl: "https://img-tac.sm.mncdn.com/img/attributes/pile-kanun.jpeg" },
      { id: "duz", label: "D\xFCz Diki\u015F", ratio: 1, preferred: false, imageUrl: "https://img-tac.sm.mncdn.com/img/attributes/pile-ekstraforlu-duz-dikis.jpeg" },
      { id: "kirma", label: "K\u0131rma Pile", ratio: 2.5, preferred: false, imageUrl: "https://img-tac.sm.mncdn.com/img/attributes/pile-yatik.jpeg" }
    ];
    const TEK_KANAT_SVG = `<svg width="80" height="76" viewBox="0 0 80 76" fill="none" aria-hidden="true">
    <line x1="4" y1="8" x2="76" y2="8" stroke="#1B2A4A" stroke-width="3.5" stroke-linecap="round"/>
    <rect x="4" y="8" width="72" height="56" fill="#DDE3EE" stroke="#1B2A4A" stroke-width="1.5"/>
    <line x1="18" y1="8" x2="18" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <line x1="32" y1="8" x2="32" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <line x1="46" y1="8" x2="46" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <line x1="60" y1="8" x2="60" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <path d="M36 70 L56 70" stroke="#1B2A4A" stroke-width="1.5" stroke-linecap="round"/>
    <polygon points="56,67 56,73 63,70" fill="#1B2A4A"/>
  </svg>`;
    const CIFT_KANAT_SVG = `<svg width="80" height="76" viewBox="0 0 80 76" fill="none" aria-hidden="true">
    <line x1="4" y1="8" x2="76" y2="8" stroke="#1B2A4A" stroke-width="3.5" stroke-linecap="round"/>
    <rect x="4" y="8" width="33" height="56" fill="#DDE3EE" stroke="#1B2A4A" stroke-width="1.5"/>
    <line x1="14" y1="8" x2="14" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <line x1="25" y1="8" x2="25" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <rect x="43" y="8" width="33" height="56" fill="#DDE3EE" stroke="#1B2A4A" stroke-width="1.5"/>
    <line x1="54" y1="8" x2="54" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <line x1="65" y1="8" x2="65" y2="64" stroke="#B8C4D8" stroke-width="1" stroke-dasharray="3 3"/>
    <line x1="40" y1="8" x2="40" y2="64" stroke="#1B2A4A" stroke-width="0.8" stroke-dasharray="2 3"/>
    <path d="M27 70 L14 70" stroke="#1B2A4A" stroke-width="1.5" stroke-linecap="round"/>
    <polygon points="14,67 14,73 7,70" fill="#1B2A4A"/>
    <path d="M53 70 L66 70" stroke="#1B2A4A" stroke-width="1.5" stroke-linecap="round"/>
    <polygon points="66,67 66,73 73,70" fill="#1B2A4A"/>
  </svg>`;
    let formState = {
      en: 0,
      boy: 0,
      pileId: "boru",
      pileOrani: 3,
      kanat: "tek",
      kanatCount: 1,
      enValid: false,
      boyValid: false
    };
    function buildSelectOptions(min, max) {
      const parts = ['<option value="">Se\xE7in</option>'];
      for (let i = min; i <= max; i++) {
        parts.push(`<option value="${i}">${i} cm</option>`);
      }
      return parts.join("");
    }
    function buildTestimonialsHTML() {
      var _a;
      const assetUrls = JSON.parse(
        ((_a = document.getElementById("ds-testimonial-assets")) == null ? void 0 : _a.textContent) || "{}"
      );
      const videoSrc = assetUrls.videoUrl || "";
      const imgSrc = assetUrls.imageUrl || "";
      return `
      <div class="ds-testimonial">
        ${videoSrc ? `<div class="ds-testimonial-media"><video id="ds-testimonial-video" src="${videoSrc}" autoplay muted loop playsinline></video><button class="ds-testimonial-mute-btn" id="ds-testimonial-mute-btn" type="button" aria-label="Sesi a\xE7/kapat"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg></button></div>` : ""}
        <div class="ds-testimonial-body">
          <div class="ds-testimonial-stars">\u2605\u2605\u2605\u2605\u2605</div>
          <p class="ds-testimonial-text">"Salonuma fon ve t\xFCl ald\u0131m, tam arad\u0131\u011F\u0131m kombinasyondu. \xD6l\xE7\xFCleri WhatsApp'tan ilettim, tam istedi\u011Fim gibi dikildi. 4 g\xFCnde kap\u0131ya geldi, montaj\u0131 da \xE7ok kolayd\u0131. Fiyat kalite dengesi m\xFCkemmel, \xE7ok memnun kald\u0131m."</p>
          <span class="ds-testimonial-author">\u2014 Fatma Y\u0131ld\u0131z, Bursa</span>
        </div>
      </div>
      <div class="ds-testimonial">
        ${imgSrc ? `<div class="ds-testimonial-media"><img src="${imgSrc}" alt="M\xFC\u015Fteri odas\u0131" loading="lazy"></div>` : ""}
        <div class="ds-testimonial-body">
          <div class="ds-testimonial-stars">\u2605\u2605\u2605\u2605\u2605</div>
          <p class="ds-testimonial-text">"Oturma odama fon perde ald\u0131m, renk foto\u011Fraftaki gibi \xE7\u0131kt\u0131, hi\xE7 yan\u0131lmad\u0131m. Kuma\u015F kalitesi ger\xE7ekten iyi, elle tutunca belli oluyor. Dikimi de \xE7ok d\xFCzg\xFCn. Kesinlikle tavsiye ederim, ikinci odaya da buradan alaca\u011F\u0131m."</p>
          <span class="ds-testimonial-author">\u2014 H\xFCseyin Kaya, Ankara</span>
        </div>
      </div>
    `;
    }
    function buildOrderForm(container) {
      var _a, _b, _c, _d, _e, _f;
      const apiUrl = ((_b = (_a = document.getElementById("ds-form")) == null ? void 0 : _a.dataset) == null ? void 0 : _b.apiUrl) || "https://app.inanctekstil.store";
      const maxBoy = (_c = product == null ? void 0 : product.maxBoy) != null ? _c : 300;
      const variant = (product == null ? void 0 : product.variants.find((v) => v.id === selectedVariantId)) || (product == null ? void 0 : product.variants[0]);
      const waText = encodeURIComponent(
        `Merhaba! ${(product == null ? void 0 : product.title) || "perde"}${(variant == null ? void 0 : variant.sku) ? ` (${variant.sku})` : ""} \xFCr\xFCn\xFCn\xFC inceledim ve odamda g\xF6rselini olu\u015Fturdum. \xD6l\xE7\xFC ve fiyat bilgisi almak istiyorum.`
      );
      const waHref = `https://wa.me/905543422428?text=${waText}`;
      const WA_SVG = `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>`;
      const IG_SVG = `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>`;
      container.innerHTML = `
      <div id="ds-result-contact">
        ${buildProductSummaryHTML()}
        <p id="ds-result-contact-text">Be\u011Fendiniz mi? Fiyat i\xE7in yaz\u0131n.</p>
        <div id="ds-result-contact-links">
          <a id="ds-result-wa-link" href="${waHref}" target="_blank" rel="noopener noreferrer" class="ds-contact-link ds-contact-link-wa">
            ${WA_SVG} WhatsApp'tan Fiyat Al
          </a>
          <p id="ds-wa-response-time">\u26A1 15 dk'da yan\u0131t &nbsp;\xB7&nbsp; \u2702\uFE0F 5 i\u015F g\xFCn\xFCnde haz\u0131r &nbsp;\xB7&nbsp; \u{1F4E6} \xFCcretsiz kargo</p>
          <a id="ds-result-ig-link" href="https://ig.me/m/inanc_tekstil" target="_blank" rel="noopener noreferrer" class="ds-contact-link ds-contact-link-ig">
            ${IG_SVG} Instagram'dan Fiyat Al
          </a>
        </div>
        <div id="ds-testimonials">
          ${buildTestimonialsHTML()}
        </div>
        <div id="ds-direct-order-divider">\u2014 veya \u2014</div>
        <button type="button" id="ds-toggle-order-form">\xD6l\xE7\xFC girerek sipari\u015F ver \u2192</button>
      </div>

      <div id="ds-direct-order-wrap" style="display:none;">
        <form id="ds-form" data-api-url="${apiUrl}">

          <div class="ds-form-section">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
              <span class="ds-form-label" style="margin-bottom:0;">\xD6l\xE7\xFCler</span>
              <button type="button" id="ds-measure-guide-btn" style="
                background:none;border:none;padding:0;cursor:pointer;
                font-size:0.75rem;font-weight:500;color:#1B2A4A;
                font-family:var(--font-body--family,Inter,sans-serif);
                text-decoration:underline;text-underline-offset:2px;
              ">Perde \xD6l\xE7\xFCs\xFC Nas\u0131l Al\u0131n\u0131r? \u2192</button>
            </div>
            <div class="ds-dimensions">
              <div class="ds-dimension-field">
                <label for="ds-en">En (cm)</label>
                <select id="ds-en">${buildSelectOptions(10, 1e3)}</select>
              </div>
              <div class="ds-dimension-field">
                <label for="ds-boy">Boy (cm)</label>
                <select id="ds-boy">${buildSelectOptions(10, maxBoy)}</select>
              </div>
            </div>
          </div>

          <div class="ds-form-section">
            <span class="ds-form-label">Pile Modeli</span>
            <div class="ds-pile-grid" id="ds-pile-grid">
              ${PILE_OPTIONS.map((p) => `
                <div class="ds-pile-card${p.id === formState.pileId ? " selected" : ""}" data-pile-id="${p.id}" data-pile-ratio="${p.ratio}" role="button" tabindex="0" aria-pressed="${p.id === formState.pileId}" style="position:relative;">
                  ${p.preferred ? `<span style="position:absolute;top:6px;left:6px;z-index:2;background:#1B2A4A;color:#fff;font-size:9px;font-weight:700;letter-spacing:0.04em;padding:2px 6px;border-radius:4px;font-family:var(--font-body--family,Inter,sans-serif);text-transform:uppercase;">\xD6nerilen</span>` : ""}
                  <div class="ds-pile-card__img">
                    <img src="${p.imageUrl}" alt="${p.label}" loading="lazy">
                  </div>
                  <div class="ds-pile-card__body">
                    <div class="ds-pile-card__name">${p.label}</div>
                    <div class="ds-pile-card__ratio">\xD7${p.ratio}</div>
                  </div>
                </div>
              `).join("")}
            </div>
          </div>

          <div class="ds-form-section">
            <span class="ds-form-label">Kanat</span>
            <div class="ds-kanat-options">
              <div class="ds-kanat-option${formState.kanat === "tek" ? " selected" : ""}" data-kanat="tek" data-count="1" role="button" tabindex="0" aria-pressed="${formState.kanat === "tek"}">
                ${TEK_KANAT_SVG}
                <div class="ds-kanat-option__label">Tek Kanat</div>
                <div class="ds-kanat-option__desc">Tek par\xE7a, tek tarafa a\xE7\u0131l\u0131r</div>
              </div>
              <div class="ds-kanat-option${formState.kanat === "cift" ? " selected" : ""}" data-kanat="cift" data-count="2" role="button" tabindex="0" aria-pressed="${formState.kanat === "cift"}">
                ${CIFT_KANAT_SVG}
                <div class="ds-kanat-option__label">\xC7ift Kanat</div>
                <div class="ds-kanat-option__desc">\u0130ki par\xE7a, ortadan her iki yana a\xE7\u0131l\u0131r</div>
              </div>
            </div>
          </div>

          <div id="ds-price-block">
            <div id="ds-price-label">Fiyat</div>
            <div id="ds-price-value">\u2014 TL</div>
            <div id="ds-price-formula">En ve boy girin</div>
          </div>

          <div id="ds-checkout-error"></div>
          <button type="submit" id="ds-order-btn" disabled>Sipari\u015F Ver \u2192</button>
          <p id="ds-delivery-promise">Bug\xFCn sipari\u015F verin \u2022 5 i\u015F g\xFCn\xFCnde haz\u0131r \u2022 \xDCcretsiz kargo</p>
        </form>
      </div>
    `;
      const testVideo = document.getElementById("ds-testimonial-video");
      const testMuteBtn = document.getElementById("ds-testimonial-mute-btn");
      const ICON_SOUND_ON = `<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>`;
      const ICON_SOUND_OFF = `<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>`;
      if (testVideo && testMuteBtn) {
        let toggleMute2 = function() {
          testVideo.muted = !testVideo.muted;
          testMuteBtn.innerHTML = testVideo.muted ? ICON_SOUND_OFF : ICON_SOUND_ON;
          testMuteBtn.setAttribute("aria-label", testVideo.muted ? "Sesi a\xE7" : "Sesi kapat");
        };
        var toggleMute = toggleMute2;
        testMuteBtn.innerHTML = ICON_SOUND_OFF;
        testMuteBtn.setAttribute("aria-label", "Sesi a\xE7");
        testMuteBtn.addEventListener("click", toggleMute2);
        testVideo.addEventListener("click", toggleMute2);
        testVideo.style.cursor = "pointer";
      }
      (_d = document.getElementById("ds-result-wa-link")) == null ? void 0 : _d.addEventListener("click", () => {
        var _a2, _b2;
        (_a2 = window.fbq) == null ? void 0 : _a2.call(window, "track", "Contact", { content_ids: product ? [String(product.id)] : [], currency: "TRY", value: 300 });
        (_b2 = window.posthog) == null ? void 0 : _b2.capture("direct_sale_whatsapp_clicked", { product_id: product == null ? void 0 : product.id, variant_id: selectedVariantId, phase: "result" });
      });
      (_e = document.getElementById("ds-result-ig-link")) == null ? void 0 : _e.addEventListener("click", () => {
        var _a2, _b2;
        (_a2 = window.fbq) == null ? void 0 : _a2.call(window, "track", "Contact", { content_ids: product ? [String(product.id)] : [], currency: "TRY", value: 200 });
        (_b2 = window.posthog) == null ? void 0 : _b2.capture("direct_sale_instagram_clicked", { product_id: product == null ? void 0 : product.id, variant_id: selectedVariantId, phase: "result" });
      });
      let formBound = false;
      (_f = document.getElementById("ds-toggle-order-form")) == null ? void 0 : _f.addEventListener("click", () => {
        var _a2;
        const wrap = document.getElementById("ds-direct-order-wrap");
        const btn = document.getElementById("ds-toggle-order-form");
        if (!wrap) return;
        const isOpen = wrap.style.display !== "none";
        wrap.style.display = isOpen ? "none" : "block";
        if (btn) btn.textContent = isOpen ? "\xD6l\xE7\xFC girerek sipari\u015F ver \u2192" : "formu kapat \u2191";
        if (!isOpen) {
          if (!formBound) {
            formBound = true;
            bindDirectOrderForm();
            (_a2 = window.posthog) == null ? void 0 : _a2.capture("direct_sale_order_form_expanded", { variant_id: selectedVariantId });
          }
          wrap.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }
    function bindDirectOrderForm() {
      var _a, _b, _c;
      document.querySelectorAll(".ds-pile-card").forEach((card) => {
        card.addEventListener("click", () => {
          const el = card;
          formState.pileId = el.dataset.pileId;
          formState.pileOrani = parseFloat(el.dataset.pileRatio);
          document.querySelectorAll(".ds-pile-card").forEach((c) => {
            c.classList.remove("selected");
            c.setAttribute("aria-pressed", "false");
          });
          el.classList.add("selected");
          el.setAttribute("aria-pressed", "true");
          recalcPrice();
        });
        card.addEventListener("keydown", (e) => {
          const ke = e;
          if (ke.key === "Enter" || ke.key === " ") card.click();
        });
      });
      document.querySelectorAll(".ds-kanat-option").forEach((opt) => {
        opt.addEventListener("click", () => {
          const el = opt;
          formState.kanat = el.dataset.kanat;
          formState.kanatCount = parseInt(el.dataset.count, 10);
          document.querySelectorAll(".ds-kanat-option").forEach((o) => {
            o.classList.remove("selected");
            o.setAttribute("aria-pressed", "false");
          });
          el.classList.add("selected");
          el.setAttribute("aria-pressed", "true");
          recalcPrice();
        });
        opt.addEventListener("keydown", (e) => {
          const ke = e;
          if (ke.key === "Enter" || ke.key === " ") opt.click();
        });
      });
      const enInput = document.getElementById("ds-en");
      const boyInput = document.getElementById("ds-boy");
      enInput == null ? void 0 : enInput.addEventListener("change", () => {
        formState.en = parseInt(enInput.value, 10) || 0;
        formState.enValid = !!enInput.value;
        recalcPrice();
      });
      boyInput == null ? void 0 : boyInput.addEventListener("change", () => {
        formState.boy = parseInt(boyInput.value, 10) || 0;
        formState.boyValid = !!boyInput.value;
        recalcPrice();
      });
      (_a = document.getElementById("ds-form")) == null ? void 0 : _a.addEventListener("submit", (e) => {
        e.preventDefault();
        onOrderSubmit();
      });
      if (!document.getElementById("ds-measure-modal")) {
        let closeModal2 = function() {
          modal.style.display = "none";
          modal.querySelectorAll("iframe").forEach((f) => {
            f.src = f.src;
          });
        };
        var closeModal = closeModal2;
        const modal = document.createElement("div");
        modal.id = "ds-measure-modal";
        modal.style.cssText = `
        display:none;position:fixed;inset:0;z-index:9999;
        background:rgba(0,0,0,0.6);overflow-y:auto;
        padding:16px;box-sizing:border-box;
        align-items:flex-start;justify-content:center;
      `;
        modal.innerHTML = `
        <div style="
          background:#fff;border-radius:16px;max-width:760px;width:100%;
          padding:28px 24px 32px;position:relative;
          font-family:var(--font-body--family,Inter,sans-serif);
        ">
          <button id="ds-measure-modal-close" type="button" aria-label="Kapat" style="
            position:absolute;top:16px;right:16px;
            background:none;border:1.5px solid #E5E5E5;border-radius:50%;
            width:32px;height:32px;cursor:pointer;display:flex;
            align-items:center;justify-content:center;color:#555;font-size:16px;
          ">\u2715</button>
          <h2 style="margin:0 0 8px;font-size:1.25rem;color:#1B2A4A;">Perde \xD6l\xE7\xFCs\xFC Nas\u0131l Al\u0131n\u0131r?</h2>
          <p style="margin:0 0 24px;font-size:0.875rem;color:#666;">Do\u011Fru \xF6l\xE7\xFC, m\xFCkemmel perdenin ilk ad\u0131m\u0131d\u0131r. A\u015Fa\u011F\u0131daki videolardan \xF6l\xE7\xFC alma y\xF6ntemlerini \xF6\u011Frenin.</p>
          <div id="ds-measure-modal-videos" style="display:grid;grid-template-columns:repeat(3,1fr);gap:16px;">
            <div>
              <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;margin-bottom:8px;background:#ddd;border-radius:8px;">
                <iframe src="https://www.youtube-nocookie.com/embed/k8r_DUzKrlI" title="Kalorifer \xDCst\xFC \xD6l\xE7\xFC Alma" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen loading="lazy" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;border-radius:8px;"></iframe>
              </div>
              <strong style="display:block;margin-bottom:4px;font-size:0.8rem;color:#1B2A4A;">Kalorifer \xDCst\xFC \xD6l\xE7\xFC Alma</strong>
              <span style="font-size:0.75rem;color:#666;">Kalorifer \xFCst\xFCne monte edilecek perdeler i\xE7in do\u011Fru \xF6l\xE7\xFC alma y\xF6ntemi.</span>
            </div>
            <div>
              <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;margin-bottom:8px;background:#ddd;border-radius:8px;">
                <iframe src="https://www.youtube-nocookie.com/embed/1BR3onEeMxk" title="Cam Hizas\u0131nda \xD6l\xE7\xFC Alma" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen loading="lazy" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;border-radius:8px;"></iframe>
              </div>
              <strong style="display:block;margin-bottom:4px;font-size:0.8rem;color:#1B2A4A;">Cam Hizas\u0131nda \xD6l\xE7\xFC Alma</strong>
              <span style="font-size:0.75rem;color:#666;">Cam hizas\u0131nda as\u0131lan perdeler i\xE7in en ve boy \xF6l\xE7\xFClerinin nas\u0131l al\u0131naca\u011F\u0131.</span>
            </div>
            <div>
              <div style="position:relative;padding-bottom:56.25%;height:0;overflow:hidden;margin-bottom:8px;background:#ddd;border-radius:8px;">
                <iframe src="https://www.youtube-nocookie.com/embed/2yQDL8eXHc8" title="Yere Kadar Uzanan \xD6l\xE7\xFC Alma" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen loading="lazy" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;border-radius:8px;"></iframe>
              </div>
              <strong style="display:block;margin-bottom:4px;font-size:0.8rem;color:#1B2A4A;">Yere Kadar Uzanan \xD6l\xE7\xFC Alma</strong>
              <span style="font-size:0.75rem;color:#666;">Yere kadar uzanan perdeler i\xE7in do\u011Fru \xF6l\xE7\xFC alma teknikleri.</span>
            </div>
          </div>
        </div>
      `;
        document.body.appendChild(modal);
        (_b = document.getElementById("ds-measure-modal-close")) == null ? void 0 : _b.addEventListener("click", closeModal2);
        modal.addEventListener("click", (e) => {
          if (e.target === modal) closeModal2();
        });
      }
      (_c = document.getElementById("ds-measure-guide-btn")) == null ? void 0 : _c.addEventListener("click", () => {
        const modal = document.getElementById("ds-measure-modal");
        if (modal) modal.style.display = "flex";
      });
      injectStyles("ds-measure-modal-styles", `
      #ds-measure-modal > div { margin: auto 0; }
      @media (max-width: 600px) {
        #ds-measure-modal { padding: 12px !important; }
        #ds-measure-modal > div { padding: 20px 16px 24px !important; }
        #ds-measure-modal-videos { grid-template-columns: 1fr !important; }
      }
    `);
      recalcPrice();
    }
    function validateDimensions() {
      const enEl = document.getElementById("ds-en");
      const boyEl = document.getElementById("ds-boy");
      formState.en = (enEl == null ? void 0 : enEl.value) ? parseInt(enEl.value, 10) : 0;
      formState.boy = (boyEl == null ? void 0 : boyEl.value) ? parseInt(boyEl.value, 10) : 0;
      formState.enValid = !!(enEl == null ? void 0 : enEl.value);
      formState.boyValid = !!(boyEl == null ? void 0 : boyEl.value);
      return formState.enValid && formState.boyValid;
    }
    function recalcPrice() {
      var _a, _b;
      const variant = variants.find((v) => v.id === selectedVariantId);
      const base = (_a = variant == null ? void 0 : variant.price) != null ? _a : 0;
      const priceEl = document.getElementById("ds-price-value");
      const formulaEl = document.getElementById("ds-price-formula");
      const ctaBtn = document.getElementById("ds-order-btn");
      const enVal = formState.en;
      const pileR = formState.pileOrani;
      const kanatC = formState.kanatCount;
      const pileName = ((_b = PILE_OPTIONS.find((p) => p.id === formState.pileId)) == null ? void 0 : _b.label) || formState.pileId;
      if (enVal > 0 && base > 0) {
        const total = enVal / 100 * pileR * kanatC * base;
        if (priceEl) priceEl.textContent = formatPrice(total);
        if (formulaEl) formulaEl.textContent = `${enVal} cm \xD7 ${pileR} (${pileName}) \xD7 ${kanatC} kanat`;
      } else {
        if (priceEl) priceEl.textContent = "\u2014 TL";
        if (formulaEl) formulaEl.textContent = "En ve boy girin";
      }
      if (ctaBtn) {
        ctaBtn.disabled = !(formState.enValid && formState.boyValid);
      }
    }
    async function onOrderSubmit() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      if (!validateDimensions()) return;
      const apiUrlEl = document.getElementById("ds-form");
      const apiUrl = ((_a = apiUrlEl == null ? void 0 : apiUrlEl.dataset) == null ? void 0 : _a.apiUrl) || "https://app.inanctekstil.store";
      const ctaBtn = document.getElementById("ds-order-btn");
      const errDiv = document.getElementById("ds-checkout-error");
      const variant = variants.find((v) => v.id === selectedVariantId);
      function showCheckoutError(msg) {
        if (errDiv) {
          errDiv.textContent = msg;
          errDiv.style.display = "block";
        }
        if (ctaBtn) {
          ctaBtn.textContent = "Sipari\u015F Ver \u2192";
          ctaBtn.disabled = false;
        }
      }
      if (!navigator.onLine) {
        showCheckoutError("\u0130nternet ba\u011Flant\u0131n\u0131z\u0131 kontrol edin.");
        return;
      }
      if (ctaBtn) {
        ctaBtn.textContent = "Haz\u0131rlan\u0131yor\u2026";
        ctaBtn.disabled = true;
      }
      if (errDiv) errDiv.style.display = "none";
      const pileOption = PILE_OPTIONS.find((p) => p.id === formState.pileId);
      const rawPrice = formState.en / 100 * formState.pileOrani * formState.kanatCount * ((_b = variant == null ? void 0 : variant.price) != null ? _b : 0);
      const price = isFinite(rawPrice) && rawPrice > 0 ? rawPrice : 0;
      if (product) {
        (_c = window.posthog) == null ? void 0 : _c.capture("direct_sale_checkout_started", {
          product_id: product.id,
          variant_id: selectedVariantId,
          en: formState.en,
          boy: formState.boy,
          pile_stili: formState.pileId,
          price
        });
        (_d = window.fbq) == null ? void 0 : _d.call(window, "track", "InitiateCheckout", {
          content_ids: [String(product.id)],
          content_name: product.title,
          currency: "TRY",
          value: price,
          num_items: 1
        });
      }
      log.info("checkout step 1 started", { sessionToken });
      let step1Resp;
      try {
        step1Resp = await fetch(`${apiUrl}/api/checkout/item`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            cartToken: sessionToken,
            variantId: selectedVariantId,
            en: formState.en,
            boy: formState.boy,
            pileStili: (pileOption == null ? void 0 : pileOption.label) || formState.pileId,
            pileOrani: formState.pileOrani,
            kanat: formState.kanat === "tek" ? "Tek" : "\xC7ift",
            kanatCount: formState.kanatCount
          })
        });
      } catch (e) {
        log.error("checkout step 1 error", e);
        if (product) {
          (_e = window.posthog) == null ? void 0 : _e.capture("direct_sale_checkout_failed", { product_id: product.id, variant_id: selectedVariantId, error: String(e) });
        }
        showCheckoutError("Sipari\u015F ba\u015Flat\u0131lamad\u0131. L\xFCtfen tekrar deneyin.");
        return;
      }
      if (!step1Resp.ok) {
        const body = await step1Resp.text().catch(() => "");
        log.error("checkout step 1 failed", { status: step1Resp.status, body: body.slice(0, 200) });
        if (product) {
          (_f = window.posthog) == null ? void 0 : _f.capture("direct_sale_checkout_failed", { product_id: product.id, variant_id: selectedVariantId, error: `step1:${step1Resp.status}` });
        }
        showCheckoutError("Sipari\u015F ba\u015Flat\u0131lamad\u0131. L\xFCtfen tekrar deneyin.");
        return;
      }
      log.info("checkout step 2 started", { sessionToken });
      let step2Resp;
      try {
        step2Resp = await fetch(`${apiUrl}/api/checkout/complete`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ cartToken: sessionToken })
        });
      } catch (e) {
        log.error("checkout step 2 error", e);
        if (product) {
          (_g = window.posthog) == null ? void 0 : _g.capture("direct_sale_checkout_failed", { product_id: product.id, variant_id: selectedVariantId, error: String(e) });
        }
        showCheckoutError("Sipari\u015F olu\u015Fturulamad\u0131. L\xFCtfen tekrar deneyin.");
        return;
      }
      if (!step2Resp.ok) {
        const body = await step2Resp.text().catch(() => "");
        log.error("checkout step 2 failed", { status: step2Resp.status, body: body.slice(0, 200) });
        if (product) {
          (_h = window.posthog) == null ? void 0 : _h.capture("direct_sale_checkout_failed", { product_id: product.id, variant_id: selectedVariantId, error: `step2:${step2Resp.status}` });
        }
        showCheckoutError("Sipari\u015F olu\u015Fturulamad\u0131. L\xFCtfen tekrar deneyin.");
        return;
      }
      const { checkoutUrl } = await step2Resp.json();
      log.info("redirecting to checkout", { checkoutUrl });
      (_i = window.posthog) == null ? void 0 : _i.capture("direct_sale_checkout_redirect", {
        product_id: product == null ? void 0 : product.id,
        variant_id: selectedVariantId
      });
      window.location.href = checkoutUrl;
    }
    window.addEventListener("error", (e) => {
      var _a, _b;
      if ((_a = e.message) == null ? void 0 : _a.includes("_AutofillCallbackHandler")) return;
      log.error("unhandled error", e.message, e.filename, e.lineno);
      (_b = window.posthog) == null ? void 0 : _b.capture("direct_sale_js_error", {
        phase,
        message: e.message,
        status: 0
      });
    });
    window.addEventListener("unhandledrejection", (e) => {
      var _a;
      const msg = String(e.reason);
      if (msg.includes("_AutofillCallbackHandler")) return;
      log.error("unhandled rejection", e.reason);
      (_a = window.posthog) == null ? void 0 : _a.capture("direct_sale_js_error", {
        phase,
        message: msg,
        status: 0
      });
    });
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
})();
